<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-09-09 10:36:57
-->
<template>
  <div>
    <a-drawer
      :title="item.id ? '编辑账号' : '添加账号'"
      :width="width <= 720 ? '90%' : '500px'"
      :visible="visibleTwo"
      :body-style="{ paddingBottom: '80px' }"
      @close="closeTwo"
    >
    <a-spin :spinning="loadingShow">
        <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-width="width<=720?'150px':'130px'"
        class="demo-ruleForm"
      >
        <el-form-item label="所属组织" prop="organizationId">
          <a-tree-select
            v-model="ruleForm.organizationId"
            style="width: 100%"
            multiple
            allow-clear
            show-search
            :maxTagCount="1"
            :treeCheckStrictly="true"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="listData"
            placeholder="选择上级组织"
            :tree-default-expand-all="false"
            @change="selectpart"
          >
          </a-tree-select>
        </el-form-item>
        <el-form-item label="主要组织" prop="mainOrganizations">
          <el-select
            v-model="ruleForm.mainOrganizations"
            placeholder="请选择主要组织"
            @change="changeMain"
          >
            <el-option
              v-for="item in optionsData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属角色" prop="roleId">
          <el-select
            multiple
            v-model="ruleForm.roleId"
            placeholder="请选择角色"
          >
            <el-option
              v-for="(item, index) in rolesData"
              :key="index"
              :label="item.roleName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理员姓名" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入管理员姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员手机号" prop="phone">
          <el-input
            v-model="ruleForm.phone"
            placeholder="请输入管理员手机号"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!item.id" label="管理员密码" prop="password">
          <el-input placeholder="请输入管理员登录密码" v-model="ruleForm.password">
            <template slot="append"
              ><span class="pasword" @click="defaultPassword"
                >使用默认密码</span
              ></template
            >
          </el-input>
        </el-form-item>
        <el-form-item v-if="item.id" label="管理员密码">
          <el-input placeholder="请输入管理员登录密码" v-model="ruleForm.password">
            <template slot="append"
              ><span class="pasword" @click="defaultPassword"
                >使用默认密码</span
              ></template
            >
          </el-input>
        </el-form-item>
        
        <!-- <el-form-item label="站点授权" prop="station">
        <el-select
          multiple
          v-model="ruleForm.station"
          placeholder="请选择可管理的站点"
        >
          <el-option
            v-for="(item, index) in siteList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="备注" class="remard">
          <el-input
            :rows="4"
            type="textarea"
            placeholder="请输入备注"
            v-model="ruleForm.remark"
          ></el-input>
        </el-form-item>
        
      </el-form>
    </a-spin>
    <div v-if="btnShow" class="bottom">
          <div class="form-bottom">
            <el-button size="medium" @click="closeTwo">取消</el-button>
            <el-button
              size="medium"
              :loading="loading"
              type="primary"
              @click="submit"
              >保存</el-button
            >
          </div>
        </div>
      
    </a-drawer>
  </div>
</template>

<script>
import { phone } from "@/utils/reg.js";
import {
  create,
  update,
  roleList,
  organTree,
} from "./administrator_management";
import MonitorKeyboard from "@/utils/monitorKeyboard.js";
export default {
  data() {
    return {
      visibleTwo: false,
      loading: false,
      ruleForm: {
        phone: "",
        name: "",
        password: "",
        roleId: [],
        organizationId: undefined,
        remark: "",
        id: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        organizationId: [
          { required: true, message: "请选择所属组织", trigger: "blur" },
        ],
        mainOrganizations: [
          { required: true, message: "请选择所属组织", trigger: "blur" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "blur" }],
        // station: [
        //   { required: true, message: "请选择站点授权", trigger: "blur" },
        // ],
        phone: [
          {
            validator: phone,trigger: "blur" 
          },
          { required: true, message: "请输入管理员手机号", trigger: "blur" },
        ],
      },
      listData: [],
      rolesData: [],
      siteList: [],
      width: "",
      btnShow: true,
      optionsData: [],
      loadingShow:false,
    };
  },
  props: ["visible", "rolesDataTwo", "item", "addUserDataId"],
  components: {},
  mounted() {},
  methods: {
    defaultPassword() {
      this.ruleForm.password = "ganzizf@2022";
    },
    changeMain(e){
        this.ruleForm.mainOrganizations = e;
        this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
    },
    selectpart(cheacks) {
      let array = [];
      for (let index = 0; index < cheacks.length; index++) {
        const element = cheacks[index];
        array.push(Number(element))
      }
      this.getManOrign(array,2)
      this.rolesList();
    },
    getManOrign(cheacks,type){
        let array = [];
        let oneData = this.find(this.listData, cheacks, []);
        for (let index = 0; index < oneData.length; index++) {
          const element = oneData[index];
          array.push({
            value: element.value,
            label: element.title,
          });
        }
        // 数组排序
        let arrayOrgin = this.ruleForm.organizationId;
        let newArray = [];
        for (let index = 0; index < arrayOrgin.length; index++) {
          const element = arrayOrgin[index];
          for (let index = 0; index < array.length; index++) {
            const elementTwo = array[index];
            if(element == elementTwo.value){
                newArray.push(elementTwo)
            }
          }
        }
        this.optionsData = JSON.parse(JSON.stringify(newArray));
        if(type == 1 && this.ruleForm.mainOrganizations){

        }else{
           this.ruleForm.mainOrganizations = this.optionsData.length > 0 ? this.optionsData[0].value : "";
        }
        this.loadingShow = false;
    },
    getListTree() {
      this.loadingShow = true;
      organTree({
        siteId: sessionStorage.getItem("siteId"),
        columnId: this.$route.query.columnId,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "value");
          this.listData = JSON.parse(options);
          let arrayOrgan = [];
          for (
            let index = 0;
            index < this.ruleForm.organizationId.length;
            index++
          ) {
            const element = this.ruleForm.organizationId[index];
            arrayOrgan.push(Number(element));
          }
          this.getManOrign(arrayOrgan,1)
           this.rolesList();
        }
      });
    },
    find(arr, keys, selectArr) {
      arr.forEach((element) => {
        if (element.children) {
          if (keys.indexOf(element.value) != -1) {
            selectArr.push(element);
          }
          this.find(element.children, keys, selectArr);
        } else {
          if (keys.indexOf(element.value) != -1) {
            selectArr.push(element);
          }
        }
      });
      return selectArr;
    },
    close() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    getKeyboardState() {
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        _this.btnShow = false;
      });

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        _this.btnShow = true;
      });
    },
    closeTwo() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("closeTwo");
    },
    submit() {
      this.loading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = { ...this.ruleForm };
          data.organizationId = this.ruleForm.organizationId.join(",");
          data.roleId = this.ruleForm.roleId.join(",");
          if (this.item.id) {
            data.id = this.item.id;
            update(data).then((res) => {
              if (res.code == 0) {
                this.$emit("close");
              } else {
                //this.$emit("close");
              }
              this.loading = false;
            });
          } else {
            create(data).then((res) => {
              if (res.code == 0) {
                this.$emit("close");
              } else {
                //this.$emit("close");
              }
              this.loading = false;
            });
          }
        } else {
          this.loading = false;
        }
      });
    },
    rolesList() {
      roleList({
        current: 1,
        size: 1000000,
        organs: this.ruleForm.organizationId.join(","),
      }).then((res) => {
        if (res.code == 0) {
          this.rolesData = res.data.records;
          // 选取出所有角色的id
          let arrayIds = [];
          for (let index = 0; index < this.rolesData.length; index++) {
            const element = this.rolesData[index];
            arrayIds.push(element.id);
          }
          // 除去不存在的回显角色
          for (let index = 0; index < this.ruleForm.roleId.length; index++) {
            const roleid = this.ruleForm.roleId[index];
            if (arrayIds.indexOf(roleid) == -1) {
              this.ruleForm.roleId.splice(index, 1);
            }
          }
        }
      });
    },
  },
  watch: {
    visible() {
      this.visibleTwo = this.visible;
      if (this.visibleTwo) {
        if (this.item.id) {
          console.log(this.item)
          this.ruleForm = {
            organizationId: this.item.organizationId.split(","),
            organizationName: this.item.organizationName,
            mainOrganizations: this.item.mainOrganizations,
            parentId: this.item.organizationId,
            remark: this.item.remark,
            roleId: this.item.roleId.split(",").map(Number),
            phone: this.item.phone,
            name: this.item.name,
            password: "",
          };
        } else {
          this.ruleForm = {
              phone:'',
              name: "",
              password: "",
              roleId: "",
              mainOrganizations:"",
              organizationId: this.addUserDataId
                ? [this.addUserDataId]
                : undefined,
              id: "",
            };
        }
        this.rolesData = this.rolesDataTwo;
        this.getKeyboardState();
        this.getListTree();
        this.width = document.documentElement.clientWidth;
        window.onresize = () => {
          return (() => {
            this.width = document.documentElement.clientWidth;
          })();
        };
      }
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  /* height: 60px; */
  border-top: solid 1px #e5e7ec;
  width: 100%;
  padding-bottom: 22px;
  background: #fff;
  z-index: 22;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
/deep/ .ant-select-selection--multiple {
  min-height: 40px;
}
.pasword {
  cursor: pointer;
}
/deep/ .ant-drawer-body {
  padding: 0px;
  padding-top: 24px;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-drawer-title {
  font-weight: 600;
  font-size: 18px;
}
</style>